export default __webpack_public_path__ + "static/media/ic_university.b88edd1a.svg";